
import React from "react";
import FileBase64 from './base64';

export default class UploadeFileReclamo extends React.Component {
    constructor(props) {
        super()
        this.state = {
            files: props.preload !== null ? props.preload : []
        }
    }


    getFiles(files) {

        let arch = this.state.files;
        let count = arch.length;
        let esta = false;

        files.forEach(file => {
            if (parseInt(file.size) < 2281 && count < 3) {
                arch.forEach(existe => {
                    if (existe.name === file.name) {
                        esta = true;
                    }
                })
                if (!esta) {
                    arch.push(file)
                    count = count + 1;
                }
            }
        })
        this.setState({ files: arch })

        this.props.onChange(this.state.files);
    }

    eliminar = async (e) => {

        let arch = this.state.files;
        let i = arch.indexOf(e);
        i !== -1 && arch.splice(i, 1);
        
        this.setState({ filse: arch })

    }
    
    /* eslint-disable jsx-a11y/anchor-is-valid */
    render() {
        let data = this.state.files;
        return (
            <>
                <br></br>
                <FileBase64
                    multiple={true}
                    onDone={this.getFiles.bind(this)} />
                <br></br>

                <ul>
                    <table>
                        {data.map((e) => (
                            <tr>
                                <td id={e.name}><li key={e.name}>{e.name}&nbsp;&nbsp;&nbsp;</li></td>
                                <td><a onClick={() => this.eliminar(e)}>eliminar</a></td>
                            </tr>
                        ))}
                    </table>
                </ul>
            </>
        );
    }
}